import { createBrowserRouter } from 'react-router';
import { RootLayout } from './RootLayout';
import { LandingPage } from './LandingPage';
import { NotFoundPage } from './NotFoundPage';
import { ByDesign, StudioRoot } from '@/features/studio/StudioRoot';
import { StudioLayout } from '@/features/studio/StudioLayout';
import { HomePage } from '@/features/studio/HomePage';
import { ServicesPage } from '@/features/studio/ServicesPage';
import { BookingPage } from '@/features/booking/BookingPage';
import { MyBookingsPage } from '@/features/my/MyBookingsPage';
import { BookingLinkPage } from '@/features/my/BookingLinkPage';
import { BrightBookRedirect, BrightHome } from '@/features/bright/BrightHome';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/', element: <LandingPage /> },
      {
        path: '/admin',
        // Platform admin (sales pipeline): its own chunk, never loaded by studio pages.
        lazy: async () => ({ Component: (await import('@/features/admin/AdminRoot')).AdminRoot }),
        children: [
          { index: true, lazy: async () => ({ Component: (await import('@/features/admin/QueuePage')).QueuePage }) },
          { path: 'leads', lazy: async () => ({ Component: (await import('@/features/admin/LeadsPage')).LeadsPage }) },
          { path: 'import', lazy: async () => ({ Component: (await import('@/features/admin/ImportPage')).ImportPage }) },
          { path: 'settings', lazy: async () => ({ Component: (await import('@/features/admin/SettingsPage')).SettingsPage }) },
        ],
      },
      {
        path: '/s/:slug',
        element: <StudioRoot />,
        children: [
          {
            path: 'owner',
            // The owner cabinet is a separate chunk: clients never download it.
            lazy: async () => ({ Component: (await import('@/features/owner/OwnerRoot')).OwnerRoot }),
            children: [
              { index: true, lazy: async () => ({ Component: (await import('@/features/owner/schedule/SchedulePage')).SchedulePage }) },
              { path: 'stats', lazy: async () => ({ Component: (await import('@/features/owner/StatsPage')).StatsPage }) },
              { path: 'settings', lazy: async () => ({ Component: (await import('@/features/owner/settings/SettingsPage')).SettingsPage }) },
              { path: 'settings/:section', lazy: async () => ({ Component: (await import('@/features/owner/settings/SettingsSection')).SettingsSection }) },
            ],
          },
          {
            element: <StudioLayout />,
            children: [
              { index: true, element: <ByDesign classic={<HomePage />} bright={<BrightHome />} /> },
              { path: 'services', element: <ServicesPage /> },
              { path: 'book', element: <ByDesign classic={<BookingPage />} bright={<BrightBookRedirect />} /> },
              { path: 'me', element: <MyBookingsPage /> },
              { path: 'b/:token', element: <BookingLinkPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
